module.exports = __webpack_public_path__ + "img/u.fef2c056.jpg";